import { Box, MenuItem, Stack } from '@mui/material';
import { OutlinedTextField } from '@my2n/react-hook-form-inputs';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { IRegisterFormData } from '../../pages/Register/validationSchema';
import { getUserCategoryOptions, UserCategories } from './utils';

export interface IUserCategoryFields {
  customUserCategoryHelperText?: React.ReactNode | string;
  customUserCategoryLabel: React.ReactNode | string;
  userCategoryHelperText?: React.ReactNode | string;
  userCategoryLabel: React.ReactNode | string;
  userCategoryPlaceholder?: string;
}

export function UserCategoryFields({
  customUserCategoryHelperText,
  customUserCategoryLabel,
  userCategoryHelperText,
  userCategoryLabel,
  userCategoryPlaceholder,
}: IUserCategoryFields) {
  const { formatMessage } = useIntl();
  const { watch } = useFormContext<IRegisterFormData>();

  const userCategoryOptions = getUserCategoryOptions(formatMessage);
  const isCustomUserCategoryValueEqualsOther = watch('userCategory') === UserCategories.OTHER;

  return (
    <Stack spacing={2}>
      <OutlinedTextField
        fullWidth
        helperText={userCategoryHelperText}
        label={userCategoryLabel}
        name="userCategory"
        select
        slotProps={{
          inputLabel: {
            shrink: true,
          },
          select: {
            displayEmpty: true,
            renderValue: (value: string) => (
              <Box color={value ? 'text.primary' : 'text.disabled'}>
                {userCategoryOptions.find((category) => category.value === value)?.label || userCategoryPlaceholder}
              </Box>
            ),
          },
        }}
        sx={{ my: 0 }}
      >
        {userCategoryOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </OutlinedTextField>
      {isCustomUserCategoryValueEqualsOther && (
        <OutlinedTextField
          helperText={customUserCategoryHelperText}
          label={customUserCategoryLabel}
          name="customUserCategory"
          fullWidth
        />
      )}
    </Stack>
  );
}
